import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function InsightCard({ article, featured = false }) {
  return (
    <article className={`insight-card ${featured ? "featured" : ""}`} data-testid={`insight-card-${article.slug}`}>
      <div className="meta-row">
        <span className="insight-category">{article.category}</span>
        <span>{article.readingTime}</span>
      </div>
      <h2 className="insight-title">{article.title}</h2>
      <p className="insight-excerpt">{article.excerpt}</p>
      <Link to={`/insights/${article.slug}`} className="card-link" data-testid={`insight-link-${article.slug}`}>
        Read the note <ArrowUpRight size={15} />
      </Link>
    </article>
  );
}
